<template>
    <div class="pin" :class="{'error': pinError}">
        <span class="pin__question">Czy chcesz ustawić PIN dla dziecka?</span>

        <div class="pin__radio">
            <div class="profile-new__radio"> 
                <input type="radio" id="pin-yes" name="pin" value="yes" v-model="isPin"/>
                <label class="label" for="pin-yes"><span>Tak</span></label>
            </div>

            <div class="profile-new__radio"> 
                <input type="radio" id="pin-no" name="pin" value="no" v-model="isPin" checked="checked"/>
                <label class="label" for="pin-no"><span>Nie</span></label>
            </div>
        </div>

        <div class="pin__wrapper" v-if="isPin === 'yes'" data-aos="fade-in">
            <label for="pin" class="pin__label">Ustal PIN: <span>(4 cyfry z przedziału 1-9)</span></label>
            <div class="pin__input">
                <input 
                    v-model="pin" 
                    id="pin" 
                    :type="showPin ? 'text' : 'password'" 
                    class="pin__input-pin"
                    @keypress="isNumber"
                />
                <IconEye class="pin__input-eye" @mousedown="showPin = !showPin" @mouseup="showPin = !showPin"></IconEye>
            </div>
        </div>
    </div>
</template>

<script>
import IconEye from "../elements/icons/IconEye.vue";

export default {
    name: "ProfileNewPin",
    components: {
        IconEye,
    },
    props: {
        pinError: {
            type: Boolean
        },
        data: {
            type: Object
        }
    },
    data() {
        return {
            pin: '',
            isPin: false,
            showPin: false
        }
    },
    watch: {
        pin(val) {
            this.$emit('savePin', val);
        },
        isPin(val) {
            this.$emit('setIsPin', val);
        }
    },
    methods: {
        isNumber(e) {
            if ((!/[1-9]/.test(e.key) && e.key !== 'Backspace') || (e.target.value.length === 4 && e.key !== 'Backspace')) {
                e.preventDefault();
            }
        }
    },
    mounted() {
        this.isPin = this.data.isPin;
        this.pin = this.data.pin;
    }
};
</script>